import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { AppDispatch, RootState } from '../../../../store/app';
import { doLogin, sendUserOtp, setSessionTimeOut, verifyEmail } from '../../../../store/AuthSlice';
import loginlogo from "../../../../assets/images/login-logo.svg"
import { Row, Form, Col, Button, Divider, Input } from 'antd';
import { FormBox, InputBox } from '../../../../components/AntdAddons';
import OtpInput from "react-otp-input"
import { assignErrorToInput } from '../../../../store/api';
import PageSpinner from '../../../../components/PageSpinner/PageSpinner';
import { rules } from '../webLogin/Rules';

import { Notification } from '../../../../config/Global';
import { WebConstant } from '../../webConstant/WebConstant';

/**
 * Path of this page given in mail confirmation with token in URL
 * that navigate user to login page after verification.
 *
 * @return {JSX.Element} Returns a div element.
 */
const VerifyAccount = ({ verificationData }: any) => {
  const [form] = Form.useForm();
  // const [otp, setOtp] = useState("");
  const navigate = useNavigate()
  const dispatch: AppDispatch = useDispatch();
  const { username, password, remember } = verificationData;
  const [loading, setLoading] = useState(false);

  // useEffect(() => {
  //   resendOtp();
  // }, [])

  const handleSubmit = (data: any) => {

    if (username != '' && password != '') {
      setLoading(true)
      const req = { username, password, otp: data.otp, remember: remember || false };
      dispatch(doLogin(req))
        .then(() => {
          setLoading(false)
          navigate("/dashboard");
          dispatch(setSessionTimeOut(true))
        })
        .catch((error: any) => {
          setLoading(false);
          assignErrorToInput(form, error?.STATUS)
        })
    }
  }


  const resendOtp = () => {
    setLoading(true)
    if (username != '' && password != '') {
      form.setFieldValue('otp', '');
      const req = { username, password };
      dispatch(sendUserOtp(req))
        .then(() => {
          setLoading(false)
          Notification.success({
            message: "Code resent on your email/phone.",
          });

        })
        .catch((error: any) => {
          setLoading(false);
          assignErrorToInput(form, error?.STATUS)
        })
    }
  }
  const otp = Form.useWatch('otp', { form, preserve: true });

  const logo = useSelector((state: RootState) => state.HOME.pageSettings?.banner?.banner_logo)


  return (
    <div className='webLoginBox'>
      <div className="login-logo">
        <Link to={'/login'} >
          <img src={WebConstant?.IMAGE_URL + logo} alt="" />
        </Link>
      </div>
      <h2 className="subtitle">Verify Your Identity</h2>
      <p>Enter the 4-digit code we sent to your email to continue.<br />This helps us keep your account secure.</p>
      <FormBox form={form} onFinish={handleSubmit} >
        <OtpInput
          containerStyle="otpInput"
          value={otp}
          inputType="number"
          onChange={(otp: any) => form.setFieldValue('otp', otp)}
          numInputs={4}
          renderInput={(props: any) => <input {...props} />}
        />
        <InputBox.Text
          className={'otp-input-hidden'}
          name="otp"
          rules={rules.otp()}
        />

        <div className='forgetPass'>
          <div className='logInBtn'>
            <Button 
            className='log_in_button secondry_btn_log_page green-btn' 
            htmlType='submit'
            loading={loading}>
              Submit
            </Button>
          </div>
          <h5 className='register_here' style={{ marginTop: '2%' }}><span onClick={() => resendOtp()}>Resend code</span></h5>
          <Divider>or</Divider>
          <h5 className='register_here'>Use Different Account?<span onClick={() => navigate("/login")}>Sign in</span></h5>

        </div>
      </FormBox>
    </div>
  )
}

export default VerifyAccount